import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';
import queryString from "query-string";

import "./MealOrderList.css"

import history from "../../../../history";
import { getSubordinateUsers } from "../../../../actions/userActions"
import { getMyOrders, getTodayOrders, correctMealOrder } from "../../../../actions/mealOrderActions";

import Modal from "../../../CustomViews/Modal";

class MealOrderList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userID: { label: "< Wszyscy >", value: null },
            modal: false,
            modalType: "",
            modalAction: null
        };
    }

    componentDidMount() {
        const queryParams = queryString.parse(history.location.search);
        const newQueryParams = Object.keys(queryParams).filter(key => ["page", "year", "month"].includes(key)).reduce((obj, key) => {
            obj[key] = queryParams[key];
            return obj;
        }, {});
        const newQueryString = queryString.stringify(newQueryParams)
        if (newQueryString !== queryString.stringify(queryParams)) history.push({ search: newQueryString });

        this.startListType = "";
        this.startPage = 1;
        this.lastFiltersParams = {};
        this.filtersParams = {};
        this.updateList();
        this.props.getSubordinateUsers();
    }

    componentDidUpdate() {
        this.updateFilters();
        this.updateList();
    }

    updateList = () => {
        this.queryParams = queryString.parse(history.location.search);
        let curFilters = this.getFilters(this.queryParams);
        this.page = this.queryParams.page > 0 ? (this.queryParams.page <= this.props.pages ? +this.queryParams.page : this.props.pages) : 1

        if (this.props.listType !== this.startListType || this.page !== this.startPage || JSON.stringify(this.lastFiltersParams) !== JSON.stringify(curFilters)) {
            if (this.props.listType !== this.startListType) this.setState({ userID: { label: "< Wszyscy >", value: null } });
            this.startListType = this.props.listType;
            this.startPage = this.page;
            this.lastFiltersParams = { ...curFilters };
            if (this.props.listType === "my") this.props.getMyOrders(this.page, curFilters);
            else if (this.props.listType === "today") this.props.getTodayOrders(this.page, curFilters);
        }
    };

    getFilters = queryParams => {
        let filters = { ...this.filtersParams };
        if (queryParams.year !== filters.year)
            if (queryParams.year !== null && queryParams.year !== undefined) filters.year = queryParams.year; else delete filters.year;
        if (queryParams.month !== filters.month)
            if (queryParams.month !== null && queryParams.month !== undefined) filters.month = queryParams.month; else delete filters.month;
        if (queryParams.userID !== filters.userID)
            if (queryParams.userID !== null && queryParams.userID !== undefined) filters.userID = queryParams.userID; else delete filters.userID;
        return filters;
    };

    updateFilters = () => {
        let filters = { ...this.filtersParams };
        if (this.props.year !== filters.year)
            if (this.props.year !== null && this.props.year !== undefined) filters.year = this.props.year; else delete filters.year
        if (this.props.month !== filters.month)
            if (this.props.month !== null && this.props.month !== undefined) filters.month = this.props.month; else delete filters.month
        if (this.state.userID.value !== filters.userID)
            if (this.state.userID.value !== null && this.state.userID.value !== undefined) filters.userID = this.state.userID.value; else delete filters.userID
        if (JSON.stringify(this.filtersParams) !== JSON.stringify(filters)) {
            this.filtersParams = filters;
            filters = { page: this.startPage, ...filters };
            history.push({ search: queryString.stringify(filters) });
        }
    };

    linkTo = destination => history.push(destination);

    monthName = month => ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"][month - 1];

    onCorrectClick = (type, orderID) => this.setState({
        modal: true,
        modalType: type,
        modalAction: orderID
    });
    
    renderModal = () => {
        if (this.state.modal) {
            return (
                <Modal
                    title="Zmiana statusu zamówienia"
                    content={<p>Czy na pewno chcesz zmienić status zamówienia z <b>{this.state.modalType === "accept" ? "Wycofane" : "Wydane"}</b> na <b>{this.state.modalType === "accept" ? "Wydane" : "Wycofane"}</b>?</p>}
                    actions={(
                        <React.Fragment>
                            <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                            <button onClick={() => this.props.correctMealOrder(this.state.modalAction)} className="ui primary button">Zmień</button>
                        </React.Fragment>
                    )}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    renderMonthMenu = () => {
        const today = new Date();
        const year = this.props.year !== null ? this.props.year : today.getFullYear();
        const month = this.props.month !== null ? this.props.month : today.getMonth() + 1;
        const todayInt = today.getFullYear() * 12 + today.getMonth();
        const selectedInt = year * 12 + month - 1;

        return (
            <div className={`ui two item menu`}>
                {selectedInt <= todayInt + 1 ? (
                    <Link to={`${history.location.pathname}?year=${Math.floor((selectedInt - 1) / 12)}&month=${(selectedInt - 1) % 12 + 1}`} className="item">
                        <div className="content">Poprzedni miesiąc</div>
                    </Link>
                ) : (
                    <div className="disabled item">
                        <div className="content">Poprzedni miesiąc</div>
                    </div>
                )}
                {selectedInt < todayInt ? (
                    <Link to={`${history.location.pathname}?year=${Math.floor((selectedInt + 1) / 12)}&month=${(selectedInt + 1) % 12 + 1}`} className="item">
                        <div className="content">Następny miesiąc</div>
                    </Link>
                ) : (
                    <div className="disabled item">
                        <div className="content">Następny miesiąc</div>
                    </div>
                )}
            </div>
        );
    };

    renderMealOrders = () => this.props.mealOrdersList.map(mealOrder => {
        return (
            <div className="ui segment" key={mealOrder.orderID}>
                <div className="ui grid">
                    <div className={`${this.props.listType !== "my" ? "two columns " : ""}row`}>
                        <div className="column">
                            <div className="ui header">Zamówienie nr: {mealOrder.orderID}</div>
                        </div>
                        {this.props.listType !== "my" ? (
                            <div className="right aligned column">
                                <div className="content">Użytkownika <b>{`${mealOrder.lname} ${mealOrder.fname}`}</b><br />{mealOrder.email}<br /><b>{mealOrder.ouName}</b></div>
                            </div>
                        ) : null}
                    </div>
                    <div className="ui divider" />
                    <div className="row">
                        <div className="ten wide column">
                            <div className="content">
                                Zamówione pozycje:
                                {mealOrder.rows.map(row => (
                                    <React.Fragment key={row.posID}>
                                        <br /><b>{row.mealDescription}</b>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                        <div className="six wide column">
                            <div className="content">
                                Wartość:<br />
                                <span className="big content">{mealOrder.foundedPrice} zł</span><br />
                                (przed dofinansowaniem <b>{mealOrder.totalPrice} zł</b>)
                            </div>
                        </div>
                    </div>
                    <div className="ui divider" />
                    <div className="two columns row">
                        <div className="column">
                            <div className="content">Złożone dnia: <b>{mealOrder.submitedOn}</b></div>
                        </div>
                        <div className="right aligned column">
                            <div className={`${mealOrder.canceled === 1 ? "red" : (mealOrder.accepted === 1 ? "green" : "orange")} content`}>
                                <b>{mealOrder.canceled === 1 ? "Wycofane" : (mealOrder.accepted === 1 ? "Wydane" : "Oczekujące")}</b>
                                {this.props.listType === "today" && this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID && (mealOrder.canceled === 1 || mealOrder.accepted === 1) && mealOrder.reportID === null ? (
                                    <React.Fragment>
                                        &emsp;<button className="ui primary button" type="button" onClick={() => this.onCorrectClick(mealOrder.accepted === 1 ? "cancel" : "accept", mealOrder.orderID)}>Zmień status</button>
                                    </React.Fragment>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    renderPagination = () => {
        let buttons = [];
        let ellipsis = true;

        buttons.push(this.renderPaginationButton(-2));
        for (let i = 1; i <= this.props.pages; i++) {
            if ((i < this.page && i - 1 > 0 && this.page - i > (this.page === this.props.pages ? 2 : 1) && this.page - 1 > (this.page === this.props.pages ? 4 : 3)) || (i > this.page && this.props.pages - i > 0 && i - this.page > (this.page === 1 ? 2 : 1) && this.props.pages - this.page > (this.page === 1 ? 4 : 3))) {
                if (ellipsis) {
                    buttons.push(this.renderPaginationButton(i, true));
                    ellipsis = false;
                }
                continue;
            }
            if (i === this.page) ellipsis = true;
            buttons.push(this.renderPaginationButton(i));
        }
        buttons.push(this.renderPaginationButton(-1));

        return (
            <div className="ui pagination menu">
                {buttons}
            </div>
        );
    };

    renderPaginationButton = (page, ellipsis = false) => {
        let destination = page > 0 ? page : (page === -2 ? +this.page - 1 : +this.page + 1);
        return (
            <React.Fragment key={page}>
                {(destination < 1 || destination > this.props.pages || ellipsis) ? (
                    <div className="disabled item">{ellipsis ? "..." : (page > 0 ? page : (page === -2 ? "<" : ">"))}</div>
                ) : (
                    <Link to={`${history.location.pathname}?${queryString.stringify({ page: destination, ...this.filtersParams })}`} className={`${(destination < 1 || destination > this.props.pages) ? "disabled " : ""}item${page === this.page ? " active" : ""}`}>
                        <div className="content">{page > 0 ? page : (page === -2 ? "<" : ">")}</div>
                    </Link>
                )}
            </React.Fragment>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="meal-order-list-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className={`${this.props.listType === "my" ? "active " : ""}item`}>
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className={`${this.props.listType === "today" ? "active " : ""}item`}>
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID && this.props.listType === "today" ? (
                        <div className="ui two item menu">
                            <Link to="/meal-orders/today" className="active item">
                                <div className="content">Korekta statusów zamówień</div>
                            </Link>
                            <Link to="/meal-orders/missing" className="item">
                                <div className="content">Dodanie brakujących zamówień</div>
                            </Link>
                        </div>
                    ) : null}
                    {this.props.listType === "my" ? (this.renderMonthMenu()) : (
                        <div className="ui container">
                            <div className="column">
                                Użytkownik:
                                <Select
                                    value={this.state.userID}
                                    onChange={value => this.setState({ userID: value })}
                                    options={[{ label: "< Wszyscy >", value: null }, ...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u.userID } })]}
                                    placeholder="Użytkownik"
                                    noOptionsMessage={() => "Nie znaleziono użytkownika"}
                                    maxMenuHeight="400px"
                                />
                            </div>
                        </div>
                    )}
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.listType === "my" ? (
                            <div className="ui large header">
                                <div className="content">Zamówienia w miesiącu: {this.monthName(this.props.month)} {this.props.year}</div>
                            </div>
                        ) : null}
                        {this.props.mealOrdersList.length ? (
                            <React.Fragment>
                                {this.renderMealOrders()}
                                <div className="ui divider" />
                                {this.renderPagination()}
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="utensils icon"></i>
                                        <div className="content">Nie odnaleziono zamówień</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    mealOrdersList: state.mealOrder.list,
    usersList: state.user.list,
    pages: state.mealOrder.pages,
    year: state.mealOrder.year,
    month: state.mealOrder.month
});

export default connect(mapStateToProps, { getSubordinateUsers, getMyOrders, getTodayOrders, correctMealOrder })(MealOrderList);